var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-confirm',{attrs:{"confirm-title":"auth.mfa_disabled","description":"auth.mfa_info","buttonConfirmTitle":''},on:{"confirm":function($event){return _vm.$emit('confirmDisabled')},"cancel":function($event){return _vm.$emit('closeModal')}}},[_c('icon-security',{attrs:{"size":100}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }